/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
import { getToken, setToken, removeToken, setRefreshToken } from "@/utils/auth";
import { resetRouter } from "@/router";
// eslint-disable-next-line import/no-cycle
import { authLogin, authInfo } from "@/api/auth";

// get user info remote
const state = {
  token: getToken(),
  id: -1,
  name: "",
  en_name: "",
  username: "",
  permissions: [],
  role: {},
  avatar: null,
  info: null,
  team_members: [],
  sso_user_info: {}
};
const mutations = {
  SET_TOKEN: (State, token) => {
    state.token = token;
  },
  SET_REFRESH_TOKEN: (State, token) => {
    state.token = token;
  },
  SET_NAME: (State, name) => {
    state.name = name;
  },
  SET_ID: (State, id) => {
    state.id = id;
  },
  SET_ENNAME: (State, en_name) => {
    state.en_name = en_name;
  },
  SET_USERNAME: (State, username) => {
    state.username = username;
  },
  SET_PERMISSIONS: (State, permissions) => {
    state.permissions = permissions;
  },
  SET_ROLE: (State, role) => {
    state.role = role;
  },
  SET_TEAM_MEMBERS: (State, {
    team_members,
    name
  }) => {
    if (team_members.length > 0) {
      state.team_members = [...team_members, {
        id: state.id,
        name: `${name}（小组长）`,
        username: `${name}`
      }];
    } else {
      state.team_members = [];
    }
  },
  SET_AVATAR: (State, avatar) => {
    state.avatar = avatar;
  },
  SET_INFO: (State, info) => {
    state.info = info;
  },
  SET_SSO_INFO: (State, info) => {
    state.sso_user_info = info;
  },
  RESET_STATE: State => {
    state.permissions = [];
    state.id = -1;
    state.name = "";
    state.username = "";
    state.role = {};
    state.avatar = null;
    state.info = null;
    state.team_members = [];
  }
};
const actions = {
  getInfo({
    commit
  }) {
    return new Promise((resolve, reject) => {
      authInfo().then(response => {
        const {
          data
        } = response;
        commit("SET_NAME", `${data.name || data.username} (${data.role.name})`);
        commit("SET_ENNAME", data.en_name || data.username);
        commit("SET_USERNAME", data.username);
        commit("SET_AVATAR", data.avatar && data.avatar.view_url);
        commit("SET_INFO", data);
        commit("SET_SSO_INFO", data.sso_user_info);
        const {
          username,
          role,
          team_members,
          id,
          name
        } = data;
        const {
          permissions
        } = role;
        commit("SET_ID", Number(id));
        commit("SET_ROLE", role);
        commit("SET_TEAM_MEMBERS", {
          team_members,
          name
        });
        commit("SET_PERMISSIONS", permissions);
        resolve({
          username,
          permissions
        });
      }).catch(error => {
        reject(error);
      });
    });
  },
  loginSuccess({
    commit
  }, {
    access_token,
    refresh_token
  }) {
    commit("SET_TOKEN", access_token);
    commit("SET_REFRESH_TOKEN", refresh_token);
    setToken(access_token);
    setRefreshToken(refresh_token);
  },
  login({
    commit
  }, userInfo) {
    return new Promise((resolve, reject) => {
      authLogin(userInfo).then(response => {
        const {
          data
        } = response;
        commit("SET_TOKEN", data.access_token);
        commit("SET_REFRESH_TOKEN", data.refresh_token);
        setToken(data.access_token);
        setRefreshToken(data.refresh_token);
        resolve(true);
      }).catch(error => {
        reject(error);
      });
    });
  },
  // user logout
  logout({
    commit
  }) {
    return new Promise(resolve => {
      commit("SET_TOKEN", "");
      commit("SET_REFRESH_TOKEN", "");
      commit("SET_PERMISSIONS", []);
      commit("SET_TEAM_MEMBERS", {
        team_members: []
      });
      removeToken();
      resetRouter();
      resolve();
    });
  },
  // remove token
  resetToken({
    commit
  }) {
    return new Promise(resolve => {
      removeToken();
      commit("RESET_STATE");
      resolve();
    });
  }
};
export default {
  namespaced: true,
  state,
  mutations,
  actions
};